export const customSortCaret = (order, _column) => {
    if (!order) return (null);
    else if (order === 'asc') return (<span className="react-bootstrap-table-sort-order dropup"><span className="caret"></span></span>);
    else if (order === 'desc') return (<span className="react-bootstrap-table-sort-order"><span className="caret"></span></span>);
}

// Highlights the row red if this condition is satisfied
export const rowStyle = (row, condition) => {
    if (condition) {
        return {
            backgroundColor: '#ffcccb'
        };
    }
    return {};
};
